export default __webpack_public_path__ + "static/media/notes.3bbd6a15.jpeg";